import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Margin } from '@mui/icons-material';

function ConfirmModal({open, setOpen, onConfirm, message}) {

  const handleClose = () => setOpen(false);

  return (
    <Dialog open={open} onClose={handleClose}>
  <DialogTitle style={{ paddingRight: '40px' }}> {/* Add paddingRight */}
    Are you sure you want to Proceed?
    <IconButton
      aria-label="close"
      onClick={handleClose}
      style={{ position: 'absolute', right: 8, top: 8 }}
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>
   <DialogContent>
        <DialogContentText style={{textAlign: 'center'}}>
        {message}
        </DialogContentText>
      </DialogContent>
  <DialogActions style={{ justifyContent: 'center', paddingBottom: '20px' }}>
    <Button onClick={handleClose} variant="outlined" style={{ fontWeight: 'bold', borderRadius: '10px' }}>
      Cancel
    </Button>
    <Button onClick={onConfirm} variant="contained" style={{ backgroundColor: '#0033cc', fontWeight: 'bold', borderRadius: '10px' }}>
      Confirm
    </Button>
  </DialogActions>
</Dialog>

  );
}

export default ConfirmModal;